<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-row>
      <div class="up">
        <el-input placeholder="输入分组名称" v-model="group_name" class="input-with-select">
          <el-select v-model="nodeid" slot="prepend" placeholder="选择网络节点" style="width: 150px">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"
              :value="item.id"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nodeip }}</span>
            </el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-plus" @click="func_addgoupKey">添加分组</el-button>
          <el-button slot="append" icon="el-icon-tickets" @click="getPlayList">播放菜单</el-button>
        </el-input>
      </div>
    </el-row>

    <el-table :data="tableData" style="width: 1150px" highlight-current-row border>
      <el-table-column type="index" width="100" label="编号 "></el-table-column>
      <el-table-column prop="node_name" label="网络节点" width="200"></el-table-column>
      <el-table-column prop="group_name" label="分组名字 " width="200"></el-table-column>
      <el-table-column prop="count" label="设备个数 " width="100"></el-table-column>
      <el-table-column prop="time" label="时间 " width="200"></el-table-column>
      <el-table-column label="操作[Operation]" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click.native.prevent="EditRow(scope.$index, tableData)"
            size="small"
            plain
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click.native.prevent="goDeleteRow(scope.$index, tableData)"
            size="small"
            plain
          >删除</el-button>
        </template>
      </el-table-column>
      <el-table-column label="实时播放" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="setPlay(scope.$index, tableData)"
            type="primary"
            size="small"
            plain
          >分组点播</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="编辑设备"
      :visible.sync="dialogVisible_adddevice"
      :before-close="handleClose_adddevice"
      width="750px"
    >
      <el-transfer
        v-model="valueT"
        filterable
        :titles="['所有设备', '选中的']"
        :button-texts="['到左边', '到右边']"
        :format="{
				  noChecked: '${total}',
				  hasChecked: '${checked}/${total}'
				}"
        :data="Tdata"
      ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_save_group">保存分组</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="分组点播"
      :visible.sync="dialogVisible_adddevice2"
      :before-close="handleClose_adddevice2"
      width="750px"
    >
      <el-form ref="form" :model="form" label-width="80px" align="left">
        <!--el-transfer
          v-model="valueT2"
          filterable
          :titles="['所有文件', '播放文件']"
          :button-texts="['到左边', '到右边']"
          :format="{
				  noChecked: '${total}',
				  hasChecked: '${checked}/${total}'
				}"
          :data="Tdata2"
          @change="countLength"
        ></el-transfer-->
		
		 <myTransfer  style="margin-left: 20px; " v-model="valueT2" :inputList="Tdata2"  @countLength="countLength"   >
		             <span slot-scope="{option}">{{ option.label }}</span>
		 </myTransfer>

        <el-form-item label="文件间隔" style="margin-top:50px">
          <el-tooltip class="item" effect="dark" content="以秒为单位，默认1秒; 一个文件播放完毕之后 间隔多少秒再播下一个" placement="right-start">
            <el-input-number v-model="form.space" @change="countLength" :min="1"></el-input-number>
          </el-tooltip>
        </el-form-item>

        <el-row class="fucko">
          <!-- el-col :span="12">
            <el-form-item label="播放模式">
              <el-select v-model="form.kind" @change="task_mode_change" placeholder="请选择任务类型">
                <el-option label="顺序播放" value="1"></el-option>
                <el-option label="随机播放" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col-->
          <el-col :span="6">
            <el-form-item label="播放次数" >
				<el-tooltip class="item" effect="dark" content="整个列表循环播放多少遍" placement="right-start">
			<!--el-form-item label="播放次数" v-show="form.kind==1" -->	
					<el-input-number v-model="form.num" @change="countLength" :min="1"></el-input-number>
				</el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
		
		

        <el-form-item label="总时长">
          <el-input-number v-model="form.length3"></el-input-number>
        </el-form-item>
      </el-form>
      <span style="text-align:center">
        <el-button type="success" @click="startGroup">播放</el-button>
      </span>
    </el-dialog>

    <el-drawer title="播放列表" :visible.sync="drawer" direction="btt">
      <div style="overflow-y:auto;height:200px">
        <div v-for="(item,index) in playList" :key="index" style="padding-left:20px">
          <div v-for="(item2,index2) in item.urlsArr" :key="index2">{{item2}}</div>
          <el-button type="warning" @click="stopGroup(item)" size="small" plain>停止</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import myTransfer from './myTransfer.vue';
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      form: {
        space: 0,
        kind: "随机播放",
        num: 1,
        length1: 0,
        length2: 0,
        length3: 0,
		mode:0,
        port: "",
        ip: "",
        fileStr: "",
        seedStr: "",
		filelist: {
		  data: [],
		  value: []
		},
      },
      drawer: false,
      playList: [],
      playNameList: [],
      tableDatatasklist: [],
      tableDatafilelist: [],
      options: [],
      nodeid: "",
      group_name: "",
      tableData: [],
      dialogVisible_adddevice: false,
      dialogVisible_adddevice2: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "自定义标签A可选",
      tag2: "自定义标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false,
      valueT: [],
      Tdata: [],
      valueT2: [],
      Tdata2: [],
      fornodeid: -1,
      forgid: -1,
      loading: false
    };
  },
  created() {
    this.reflash_devlist();
  },
     components: {
    myTransfer
  },
  methods: {
	  countfuck(){
		this.countLength();  
	  },
    stopGroup(item) {
      console.log(item);
      this.loading = true;
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("port", item.port);
      data.append("ip", item.ip);
      data.append("temptaskid", item.id);
      axios
        .post("/stop_temp_tsk.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              setTimeout(() => {
                this.getPlayList();
                this.loading = false;
              }, 5000);
            } else {
              this.loading = false;
              this.$notify.success({
                title: "Info",
                message: "获取失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    getPlayList() {
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      axios
        .post("/List_temp_tsk.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              if (res.data.dataJson != null) {
                for (var i = 0; i < res.data.dataJson.length; i++) {
                  res.data.dataJson[i].urlsArr = res.data.dataJson[
                    i
                  ].urls.split("|");
                  for (
                    var j = 0;
                    j < res.data.dataJson[i].urlsArr.length;
                    j++
                  ) {
					  var num1 = res.data.dataJson[i].urlsArr[j].indexOf("mp3/");
					  var num2 = res.data.dataJson[i].urlsArr[j].indexOf("mp3,");
					res.data.dataJson[i].urlsArr[j] = res.data.dataJson[i].urlsArr[j].substring(num1 + 4, num2);
                    res.data.dataJson[i].urlsArr[j] = Base64.decode(
                      res.data.dataJson[i].urlsArr[j]
                    );
                  }
                }
              }
              this.playList = res.data.dataJson;
              this.drawer = true;
            } else {
              this.$notify.success({
                title: "Info",
                message: "获取失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    goDeleteRow(index, rows) {
      this.$confirm("此操作将永久删除该分组, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    startGroup() {
		 
	  if( this.form.num > 0 ){
		this.form.mode = this.form.num;	  
		
	  }
	  this.form.kind =  this.form.mode;		
      var tempArr = [];
      for (var i in this.valueT2) {
        tempArr.push(this.valueT2[i]);
      }
      this.form.fileStr = tempArr.join("|");
      if (!this.form.fileStr) {
        this.$message({
          type: "warning",
          message: "没有选择文件"
        });
        return;
      }
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("playmode", this.form.mode);
      data.append("len", this.form.length3);
      data.append("port", this.form.port);
      data.append("jiange", this.form.space);
      data.append("urls", this.form.fileStr);
      data.append("ip", this.form.ip);
      data.append("seeds", this.form.seedStr);

      axios
        .post("/Create_temp_tsk.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "播放成功",
                showClose: false
              });
            } else {
              console.log(res.data);
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice2 = false;
    },
    countNum() {
      this.form.length2 = this.form.length1 + this.form.space * (this.valueT2.length - 1);
       
    },
    countSpace() {
      this.form.length2 = this.form.length1 + this.form.space * (this.valueT2.length - 1);
      this.form.length3 = this.form.length2* this.form.num + this.form.space * this.form.num;
    },
    countLength() {
      this.form.length1 = 0;
      for (var i = 0; i < this.tableDatafilelist.length; i++) {
        for (var j = 0; j < this.valueT2.length; j++) {
          if (
            this.valueT2[j] ==
            this.tableDatafilelist[i].url + "," + this.tableDatafilelist[i].len
          ) {
            this.form.length1 += parseInt(this.tableDatafilelist[i].len);
          }
        }
      }
      this.countSpace();
    },
    task_mode_change() {
      if (this.form.kind == "0") {
        this.form.num = 0;
        this.form.length3 = this.form.length2;
      } else {
        this.form.num = 1;
      }
    },
    setPlay(index, rows) {
      this.get_file_list();
      this.form.port = rows[index].nodeport3;
      this.form.ip = rows[index].nodeip;
      var tempArr = [];
      for (var i in rows[index].seedary) {
        tempArr.push(rows[index].seedary[i].seed);
      }
      this.form.seedStr = tempArr.join("|");
      this.dialogVisible_adddevice2 = true;
	  this.valueT2=[];
    },
    func_addgoupKey() {
      this.dialogVisible_adddevice = false;
      if (this.group_name.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "分组字不能为空",
          showClose: true
        });
        return;
      }
      if (this.nodeid == "") {
        this.$notify.success({
          title: "Info",
          message: "您还没有选者设备节点",
          showClose: true
        });
        return;
      }
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeid", this.nodeid);
      data.append("group_name", this.group_name);
      axios
        .post("/new_group.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    func_save_group() {
      console.log(this.valueT.length);
      if (this.valueT.length == 0) {
        return;
      }
      let strseed = "";
      if (this.valueT.length == 0) {
        this.$notify.success({
          title: "Info",
          message: "分组为空不能保存",
          showClose: false
        });
        return;
      }
      this.valueT.forEach(item => {
        strseed += item;
        strseed += "|";
      });
      strseed = strseed.substr(0, strseed.length - 1);

      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeid", this.fornodeid);
      data.append("gid", this.forgid);
      data.append("type", 1);
      data.append("seed", strseed);
      axios
        .post("/add_group_devices.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.reflash_devlist();
              this.dialogVisible_adddevice = false;
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    func_addgoup() {},

    func_adddevic() {
      this.dialogVisible_adddevice = true;
    },

    deleteRow(index, rows) {
      let gid = rows[index].id;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      axios
        .get("/del_group.php", {
          params: {
            gid: gid,
            username: username,
            passwd: passwd
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    EditRow(index, rows) {
      this.dialogVisible_adddevice = false;
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeid", rows[index].nodeid);
      data.append("gid", rows[index].id);
      axios
        .post("/get_user_nodedevs.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.Tdata = res.data.dev_info;
              this.valueT = res.data.dev_info_S;

              this.forgid = rows[index].id;
              this.fornodeid = rows[index].nodeid;
              this.dialogVisible_adddevice = true;
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常1",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    handleClose_adddevice() {
      this.dialogVisible_adddevice = false;
    },
    handleClose_adddevice2() {
      this.dialogVisible_adddevice2 = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reflash_devlist: function() {
      axios
        .get("/get_user_groups.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData = res.data.group_view;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    reflash_devlist2: function() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.options = res.data.outlableid;

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              const data = [];
              for (let i = 0; i < this.tableDatafilelist.length; i++) {
                data.push({
                  key:
                    this.tableDatafilelist[i].url +
                    "," +
                    this.tableDatafilelist[i].len,
                  label: this.tableDatafilelist[i].filename
                });
              }
              this.Tdata2 = data;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.up {
  width: 1050px;
  margin: 0 auto;
}
.el-select .el-input {
  width: 200px;
}
.el-transfer {
  text-align: left;
}

#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px auto;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/Group_mg.vue